import { Injector } from "@angular/core";
import { Ng2StateDeclaration, StatesModule } from "@uirouter/angular";
import { UIRouter } from "@uirouter/core";

export const configLazyLoadedStates = (originalState: string, states: Ng2StateDeclaration[]) => (uiRouter: UIRouter, injector: Injector, module: StatesModule) =>  {
    const registry = uiRouter.stateRegistry;
    // copy url from original state defs
    states.forEach(state => {
        const preState = registry.get(<string>state.name);
        state.url = preState.url
        state.params = preState.params;
        state.abstract = preState.abstract;
    });
    // Deregister original states
    registry.deregister(originalState);
    // Add states to module declaration
    module.states = states;
}

export const generateUrlWordMatch = (word: string) => {
    return word.split('').map((char) => `[${char}]`).join('');
} 
